import React from 'react';
import { ChevronLeft, Sparkles } from 'lucide-react';
import './WorkshopBreadcrumb.css';

/**
 * WorkshopBreadcrumb - Shows parent session context for spawned exploration sessions
 *
 * Rendered at the top of chat when the current session was spawned from a
 * Logline Workshop, providing a way to return to the parent session.
 *
 * Props:
 * - parentSession: Parent session object with { id, name, template }
 * - onReturn: Callback to navigate back to parent session
 */
export function WorkshopBreadcrumb({ parentSession, onReturn }) {
  if (!parentSession) return null;

  return (
    <div className="workshop-breadcrumb">
      <Sparkles className="workshop-breadcrumb__icon" />
      <span className="workshop-breadcrumb__text">
        Exploring from: <strong>{parentSession.name || 'Logline Workshop'}</strong>
      </span>
      <button
        onClick={onReturn}
        className="workshop-breadcrumb__return-btn"
      >
        <ChevronLeft className="workshop-breadcrumb__return-icon" />
        Return to Logline
      </button>
    </div>
  );
}

export default WorkshopBreadcrumb;
